import trpc from "../utils/trpc";
import { Button } from "../components/button/button";

interface CourseInitializedProps {
  onContinue: () => void;
}

function CourseInitializedView({ onContinue }: CourseInitializedProps) {
  const reinitCourse = trpc.course.init.useMutation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-ecru px-6 py-12 text-center">
      <div className="max-w-xl space-y-8">
        <div className="space-y-4">
          <h1 className="text-3xl font-semibold text-midnight">Course Initialized</h1>
          <p className="text-midnight/70">This course has already been initialized.</p>
          <div className="pt-2">
            <Button filled="midnight" className="mx-auto px-6 py-3 text-base" onClick={onContinue}>
              Continue to Course
            </Button>
          </div>
        </div>
        <div className="space-y-3 rounded-lg border border-sunburst/40 bg-sunburst/10 px-5 py-4">
          <p className="text-sm font-medium text-midnight">Re-initialize Course</p>
          <p className="text-sm text-midnight/70">
            Re-initializing will fetch the latest course content from Canvas and overwrite all previously cached
            content.
          </p>
          <Button
            filled="sunburst"
            className="mx-auto px-5 py-2 text-sm"
            loading={reinitCourse.isPending}
            disabled={reinitCourse.isPending}
            onClick={() => reinitCourse.mutate()}>
            {reinitCourse.isSuccess ? "Re-initialize Again" : "Re-initialize Course"}
          </Button>
          {reinitCourse.isError && (
            <p className="text-sm text-error">Re-initialization failed: {reinitCourse.error?.message}</p>
          )}
          {reinitCourse.isSuccess && <p className="text-sm text-lac-leman">Re-initialization complete.</p>}
        </div>
      </div>
    </div>
  );
}

export { CourseInitializedView as Component };
